import MarkdownRenderer from 'components/markdown/MarkdownRenderer';
import React, { useState, useEffect, useRef } from 'react'


function Intro({ questionData, questionVariables, questionText, questionStatus, onAnswerCheck, currentConceptProgress, setIntroButtonDisabled }) {

    const [hasScrolled, setHasScrolled] = useState(false);
    const [timeElapsed, setTimeElapsed] = useState(0);
    const scrollRef = useRef(null);
    const timerRef = useRef(null);

    // Check if this is the first time on this concept (currentConceptProgress === 1)
    const isFirstVisit = currentConceptProgress === 1;

    useEffect(() => {
        if (isFirstVisit) {
            // Defer state update to avoid updating parent during render
            setTimeout(() => {
                if (setIntroButtonDisabled) setIntroButtonDisabled({ disabled: true, progress: 0 });
            }, 0);

            // Start timer on first visit
            timerRef.current = setInterval(() => {
                setTimeElapsed(prev => {
                    const newTime = prev + 0.1;
                    if (newTime >= 5) {
                        clearInterval(timerRef.current);
                        if (setIntroButtonDisabled) setIntroButtonDisabled({ disabled: false, progress: 1 });
                        return 5;
                    }
                    if (setIntroButtonDisabled) setIntroButtonDisabled({ disabled: true, progress: newTime / 5 });
                    return newTime;
                });
            }, 100);

            return () => {
                if (timerRef.current) clearInterval(timerRef.current);
            };
        } else {
            // Not first visit, immediately enable button (deferred)
            setTimeout(() => {
                if (setIntroButtonDisabled) setIntroButtonDisabled({ disabled: false, progress: 1 });
            }, 0);
        }
    }, [isFirstVisit, setIntroButtonDisabled]);

    useEffect(() => {
        onAnswerCheck(() => {
            const isScrollable = scrollRef.current?.scrollHeight > scrollRef.current?.clientHeight;

            if (!isScrollable || hasScrolled) return true; // If not scrollable, no need to check scrolling
            if (scrollRef.current) {
                //scroll to end of the content
                scrollRef.current.scrollTo({
                    top: scrollRef.current.scrollHeight,
                    behavior: 'smooth'
                });
                setHasScrolled(true);
            }
            return
        });
    }, [onAnswerCheck, hasScrolled, scrollRef]);

    const content = questionData?.data?.content || "Something went wrong rendering this segment, please move on.";

    // Check if already at bottom on mount or content change
    useEffect(() => {
        if (scrollRef.current) {
            const isAtBottom = scrollRef.current.scrollTop + scrollRef.current.clientHeight >= scrollRef.current.scrollHeight - 50;
            if (isAtBottom) {
                setHasScrolled(true);
            }
        }
    }, [content]);


    return (
        <div className='flex items-center justify-center flex-col w-full p-2 pt-16 sm:pt-2 md:p-4 break-small:p-4  h-full'>
            <div ref={scrollRef} onScroll={
                () => {
                    if (scrollRef.current.scrollTop + scrollRef.current.clientHeight >= scrollRef.current.scrollHeight - 50) {
                        setHasScrolled(true);
                    }
                }
            } className="min-h-96 min-w-min text-left text-2xl w-full break-small:w-[730px] break-big:w-[800px] overflow-y-auto pr-1">
                <MarkdownRenderer content={content} />
            </div>
        </div>

    )
}

export default Intro; 